import { AgGridReact } from "ag-grid-react";
import React, { useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { defaultGridOptions } from "src/config/agGrid";
import { getAllReports, getReportsSearchQuery } from "src/reducers";
import type { AppState } from "src/types";
import { getColumns } from "./columns";
import { GridWrapper, TableContainer } from "./styles";

const Table = (): React.ReactElement => {
  const gridRef = useRef<AgGridReact>(null);
  const searchQuery = useSelector(({ app }: { app: AppState }) =>
    getReportsSearchQuery(app),
  );
  const allReports = useSelector(({ app }: { app: AppState }) =>
    getAllReports(app, searchQuery),
  );

  const columns = getColumns();

  const rowData = useMemo(() => {
    return allReports.filter((report) => report.id != null);
  }, [allReports]);

  return (
    <TableContainer>
      <GridWrapper>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columns}
          animateRows={true}
          getRowId={(params) => String(params.data?.id || "")}
          {...defaultGridOptions}
        />
      </GridWrapper>
    </TableContainer>
  );
};

export default Table;
